@if (!hideBanner) {
  <div class="fulfill-update-banner__container">
    @if (order?.updateType?.length > 0 || order?.updateTypeV2?.length > 0) {
      <pdq-banner variant="attention" [bannerTitle]="'Order modified in eCommerce platform'">
        @if (displayBannerInfo) {
          @switch (updateAction) {
            @case (UpdateAction.SYNC) {
              <ul>
                <li>This order was modified and may have changed its shipping rate</li>
                <li>
                  Sync, order may move back to assign / verify <after></after> this action, generate a label with the
                  updated rate
                </li>
                @if (order?.updateType?.includes(OrderUpdateCase.SHIPPING_INFO)) {
                  <li>Shipping address has changed</li>
                }
                @if (order?.updateType?.includes(OrderUpdateCase.LINE_ITEMS_CHANGED)) {
                  <li>Order items has changed</li>
                }
                @if (order?.updateTypeV2?.includes(OrderUpdateCase.LINE_ITEMS_LOCATION_CHANGED)) {
                  <li>Order items location has changed</li>
                }
              </ul>
              <div class="fulfill-update-banner__actions">
                <pdq-button
                  variant="light"
                  label="Sync"
                  [loading]="loading"
                  (onClick)="onSyncSubmit($event)"></pdq-button>
                <pdq-button
                  variant="info"
                  label="Dismiss"
                  plain="true"
                  (onClick)="onDismiss($event, OrderEvents.FULFILL_UPDATE_DISMISSED)"></pdq-button>
              </div>
            }
            @case (UpdateAction.APPROVE) {
              <ul>
                <li>This order has been synced with latest eCommerce updates</li>
                <li>and has been updated here too</li>
                @if (order?.updateType?.includes('financial')) {
                  <li>Financial status has been changed</li>
                }
              </ul>
              <pdq-button
                variant="light"
                label="Approve"
                (onClick)="onDismiss($event, OrderEvents.FULFILL_UPDATE_APPROVED)"></pdq-button>
            }
          }
        }
      </pdq-banner>
    }
    @if (hasPendingUpdates) {
      <pending-updates-warning
        (onOrdersUpdated)="handleOrdersUpdated($event)"
        [orders]="fulfillService.panelState === PanelState.ORDER ? [order] : batch.orders"></pending-updates-warning>
    }
  </div>
}
